<template>
  <div>
    <v-dialog v-model="Acknowledged" width="500px" persistent>
      <v-card color="white" height="300px">
        <v-toolbar
          class="elevation-2 white--text"
          color="blueColorVariant9"
          dense
          >Violation Status</v-toolbar
        >
        <div align="center" class="pt-10 fontsize25px">
          Motorist
          <span class="font-weight-bold blueColorVariant9--text">
            {{ this.$store.getters.get_motorist_name.user_name }}
          </span>
          has successfully acknowledged the violation
        </div>
        <v-card-actions class="mt-16">
          <v-spacer />
          <v-btn
            color="blueColorVariant9"
            depressed
            dark
            @click="AcknowledgedEmit()"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card></v-dialog
    >
  </div>
</template>

<script>
export default {
  props: {
    Acknowledged: Boolean,
  },
  data: () => ({}),
  methods: {
    AcknowledgedEmit(Toggle) {
      this.$emit("clicked", Toggle);
    },
  },
};
</script>
